const namespaceCancellationToken = '[CancellationToken]';

export const USE_CANCELLATION_TOKEN = `${namespaceCancellationToken} USE CANCELLATION TOKEN `;
export const UPDATE_CANCELLATION_DATA = `${namespaceCancellationToken} UPDATE CANCELLATION DATA `;
export const INVALID_CANCELLATION_TOKEN = `${namespaceCancellationToken} INVALID CANCELLATION TOKEN `;
